module.exports = __webpack_public_path__ + "img/Flag_of_Somalia.2098583c.svg";